export default __webpack_public_path__ + "static/media/timeline_header_right.fcc7cc3b.png";